import { Component, inject, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/utils/utils.service';

@Component({
    selector: 'app-version-badge',
    standalone: true,
    imports: [],
    templateUrl: './version-badge.component.html',
    styleUrl: './version-badge.component.scss'
})
export class VersionBadgeComponent implements OnInit {

    private readonly utilsService = inject(UtilsService);
    version = '0.0.0.0';

    async ngOnInit(): Promise<void> {
        this.version = await this.utilsService.getVersion();
    }
}
